// extracted by mini-css-extract-plugin
module.exports = {"Scopes":"ScopeBreakdown_Scopes__3C2vq"};